<template>
  <div class="js-response-edit">
    <div class="response-header">
      <span @click="toggleDetails()">{{ response.key }}</span>

      <span class="response-edit-toggle" @click="toggleDetails()">
        <v-icon v-if="showDetails" color="secondary">mdi-menu-down</v-icon>
        <v-icon v-else color="secondary">mdi-menu-right</v-icon>
      </span>

      <v-card elevation="20" v-if="showDetails">
        <v-list-item three-line>
          <v-list-item-content>
            <div class="overline mb-4">response details</div>
            <span class="d-flex justify-end">
              <v-list-item-title class="headline mb-1">{{
                response.key
              }}</v-list-item-title>
              <v-btn
                class="dangerous-action-btn ml-2"
                @click="deleteResponse(response)"
                >delete response</v-btn
              >
            </span>
          </v-list-item-content>
        </v-list-item>

        <div class="response-details">
          <span class="response-delete d-flex justify-end">
            <v-text-field
              label="Response Prompt"
              ref="keyInput"
              id="js-response-key-edit"
              :value="response.key"
              @blur="saveResponseKey"
              @keyup.enter="saveResponseKey"
              :disabled="!manager"
              outlined
              dense
              :rules="textFieldRules"
            />
          </span>
          <v-combobox
            :value="response.options.type"
            id="js-response-type"
            :items="types"
            label="Response Type"
            @change="saveResponseType"
          ></v-combobox>

          <div
            class="choices-section"
            v-if="
              response.options.type === 'SelectOne' ||
                response.options.type === 'SelectMany'
            "
          >
            <h4>choices</h4>
            <div v-for="i in response.options.choices.length" :key="i">
              <div class="d-flex justify-end">
                <v-text-field
                  :data-index="i - 1"
                  :label="`Choice ${i}`"
                  :id="`js-response-choice-${i}`"
                  :value="response.options.choices[i - 1]"
                  @blur="saveResponseChoices"
                  :disabled="!manager"
                  outlined
                  dense
                  single-line
                />

                <v-btn
                  id="js-response-delete"
                  :data-index="i - 1"
                  class="default-action-btn ml-2"
                  small
                  @click="deleteResponseChoice"
                  >Delete</v-btn
                >
              </div>
            </div>

            <div class="d-flex justify-end">
              <v-text-field
                id="js-add-choice-input"
                outlined
                single-line
                dense
                hide-details
                v-model="newChoiceQuestion"
                @keyup.enter="addChoiceWithQuestion()"
              ></v-text-field>
              <v-btn
                class="default-action-btn ml-2"
                @click="addChoiceWithQuestion()"
                >Add Choice</v-btn
              >
            </div>
          </div>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import eventMixin from "@/mixins/eventMixin"
import validationMixin from "@/mixins/validationMixin"
export default {
  mixins: [eventMixin, validationMixin],
  props: {
    manager: { type: Boolean, default: true },
    response: { type: Object },
    showAdd: { type: Boolean, default: true },
    showDelete: { type: Boolean, default: true }
  },
  data: function() {
    return {
      types: ["SelectOne", "SelectMany", "FreeText"],
      showDetails: false,
      newChoiceQuestion: ""
    }
  },
  methods: {
    toggleDetails() {
      this.showDetails = !this.showDetails
    },
    deleteResponse(response) {
      this.fireEvent("learningResponse:remove", response)
    },
    addChoiceWithQuestion() {
      this.addResponseChoice(this.newChoiceQuestion)
      this.newChoiceQuestion = ""
    },
    saveResponseKey(e) {
      if (this.$refs.keyInput.validate()) {
        // We do some JSON gymnastics in order to deepcopy the object... maybe we can find a better solution
        let model = Object.assign({}, JSON.parse(JSON.stringify(this.response)))
        model.key = e.target.value
        this.fireEvent("learningResponse:save", model)

        this.$refs.keyInput.reset()
      }
    },
    saveResponseValue(e) {
      let model = Object.assign({}, JSON.parse(JSON.stringify(this.response)))
      model.key = e.target.value
      this.fireEvent("learningResponse:save", model)
    },
    saveResponseType(e) {
      let model = Object.assign({}, JSON.parse(JSON.stringify(this.response)))

      if (model.options === "") {
        model.options = { type: e, choices: [] }
      } else {
        model.options.type = e
      }
      this.fireEvent("learningResponse:save", model)
    },
    addResponseChoice(choiceString) {
      let model = Object.assign({}, JSON.parse(JSON.stringify(this.response)))
      model.options.choices.push(choiceString)
      this.fireEvent("learningResponse:save", model)
    },
    saveResponseChoices(e) {
      let model = Object.assign({}, JSON.parse(JSON.stringify(this.response)))
      let index = e.target.getAttribute("data-index")
      if (index > model.options.choices.length) {
        model.options.choices.push(e.target.value)
      } else {
        model.options.choices[index] = e.target.value
      }
      this.fireEvent("learningResponse:save", model)
    },
    deleteResponseChoice(e) {
      let model = Object.assign({}, JSON.parse(JSON.stringify(this.response)))
      let i = e.target.parentElement.getAttribute("data-index")
      model.options.choices.splice(i, 1)
      this.fireEvent("learningResponse:save", model)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../scss/variables";
@import "../scss/buttons";

.response-header {
  font-size: 1.3em;
  padding: 5px;
  color: $dark-grey;
}

.response-edit-toggle {
  display: flex;
  float: left;
  padding: 0px 5px;
}

.response-delete {
  padding: 0px 5px;
}

.response-details {
  margin: 10px;
  padding: 15px;
  // border-left: 2px solid $light-grey;
}

.choices-section {
  padding: 20px;
}
</style>
